import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container } from "./style";
import U from "../../assets/U.png";
import { Button, Result, Spin } from "antd";
import {
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";

const CONFIRM_EMAIL = gql`
  mutation confirmEmail($input: ConfirmEmailInput!) {
    confirmEmail(confirmEmailInput: $input) {
      message
    }
  }
`;

export default function ConfirmEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [confirmEmail] = useMutation(CONFIRM_EMAIL);

  // 自动验证邮箱
  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");
      const email = searchParams.get("email");

      if (!token || !email) {
        setStatus("error");
        setErrorMessage("Invalid verification link. Missing token or email.");
        return;
      }

      try {
        const res = await confirmEmail({
          variables: {
            input: {
              email: email,
              verificationCode: token,
            },
          },
        });

        const message =
          res.data.confirmEmail?.message ||
          "Email confirmed successfully! Redirecting to login...";
        setSuccessMessage(message);
        setStatus("success");

        // 3秒后自动跳转到登录页
        setTimeout(() => {
          navigate("/Login");
        }, 3000);
      } catch (error) {
        console.error("Email confirmation failed:", error);
        setStatus("error");
        setErrorMessage(
          error.message || "Failed to confirm email. Please try again."
        );
      }
    };

    verifyEmail();
  }, [searchParams, confirmEmail, navigate]);

  return (
    <Container>
      <img src={U} alt="U" className="bg-u" />
      <div className="loginPage">
        <div className="loginLogo">
          <div className="logo1">UVITA</div>
          <div className="logo2">PRO</div>
        </div>
        <div className="loginBox">
          {status === "loading" && (
            <Result
              icon={
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
                />
              }
              title="Verifying Your Email"
              subTitle="Please wait while we confirm your email address..."
            />
          )}

          {status === "success" && (
            <Result
              status="success"
              icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
              title="Email Confirmed!"
              subTitle={
                <div>
                  <p>{successMessage}</p>
                  <p style={{ marginTop: "8px" }}>
                    Redirecting to login page in 3 seconds...
                    {/* Your coach account is verified. We’ll redirect to your portal in 3 seconds */}
                  </p>
                </div>
              }
              extra={[
                <Button
                  type="primary"
                  key="login"
                  onClick={() => navigate("/Login")}
                >
                  Login Now
                </Button>,
              ]}
            />
          )}

          {status === "error" && (
            <Result
              status="error"
              icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
              title="Email Confirmation Failed"
              subTitle={errorMessage}
              extra={[
                <Button
                  type="primary"
                  key="login"
                  onClick={() => navigate("/Login")}
                >
                  Go to Login
                </Button>,
                <Button key="register" onClick={() => navigate("/Register")}>
                  Register Again
                </Button>,
              ]}
            />
          )}
        </div>
      </div>
    </Container>
  );
}
